export class SurveyTable {
  constructor(
    public readonly userType: string,
    public readonly isTCTab: boolean,
    public readonly survey_type: string,
    public readonly ps_survey_id: number
  ) {}

  isUserAuthorized(): boolean {
    return this.isABuyer() || this.isAnOperator();
  }

  isABuyer(): boolean {
    return this.userType === 'buyer';
  }

  isAnOperator(): boolean {
    return this.userType === 'operator';
  }

  isSpecificAudience(): boolean {
    return this.survey_type === 'SPECIFIC AUDIENCE ';
  }

  isNotATrafficChannelTable(): boolean {
    return !this.isTCTab;
  }

  hasToRedirect(): boolean {
    return (
      this.isUserAuthorized() &&
      (this.isNotATrafficChannelTable() || this.isSpecificAudience())
    );
  }

  getRedirectionLink() {
    if (this.isTCTab) {
      return `/surveys/${this.ps_survey_id}/edit`;
    } else {
      return `/dashboard/${this.ps_survey_id}`;
    }
  }
}
